export default {
  allBoardingPoints: [],
}
